// extracted by mini-css-extract-plugin
export var active = "_1s-d";
export var blink = "_1s-e";
export var container = "_1s-5";
export var controls = "_1s-0";
export var controlsRight = "_1s-1";
export var fakeCursor = "_1s-c";
export var hidden = "_1s-b";
export var quillContainerSmall = "_1s-7";
export var quillEditor = "_1s-6";
export var quillEditorSmall = "_1s-8";
export var quillFormatButtons = "_1s-a";
export var quillToolbar = "_1s-9";
export var removePadding = "_1s-2";
export var state = "_1s-3";
export var stateTitle = "_1s-4";